// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CzFIKmNIcvmFr8YFOFCL {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.SPvW5Wt09Qcmku7Zdk0I {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}
.lGWPPu30BQ21jh0FbltC {
  width: 24px;
  margin-right: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/组件/FullLoading/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAAF;AAGA;EACE,WAAA;EACA,kBAAA;AADF","sourcesContent":[".fullLoading {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.icon {\n  width: 24px;\n  margin-right: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullLoading": `CzFIKmNIcvmFr8YFOFCL`,
	"content": `SPvW5Wt09Qcmku7Zdk0I`,
	"icon": `lGWPPu30BQ21jh0FbltC`
};
export default ___CSS_LOADER_EXPORT___;
